import React, { useEffect, useMemo, useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { useTheme } from '../contexts/ThemeContext';
import { MasterTourContacts } from '../components/calendar/MasterTourOpsViews';
import { getFirestoreDb } from '../utils/calendarShareService';
import { getTabEntryPublishedText } from '../utils/calendarTabDraftService';
import { formatDateLong } from '../utils/calendarContacts';

/** Read-only venue contact sheet for a shared CONTACTS-only day link. */
export default function ContactsDayShare({ ownerId, link }) {
  const { theme, isDarkMode } = useTheme();
  const [tabs, setTabs] = useState({});
  const dateKey = String(link?.dateKey || '');
  const tourId = String(link?.tourId || '');
  const venueName = useMemo(() => {
    const named = String(link?.venueName || '').trim();
    if (named && named.toUpperCase() !== 'VENUE') return named;
    return String(link?.tourName || '').trim() || 'Venue contacts';
  }, [link?.venueName, link?.tourName]);
  const cityLine = useMemo(() => {
    const city = String(link?.cityLine || '').trim();
    const dateLabel = formatDateLong(dateKey);
    return [city, dateLabel].filter(Boolean).join(' · ');
  }, [link?.cityLine, dateKey]);

  useEffect(() => {
    if (!ownerId || !tourId || !dateKey) {
      setTabs({});
      return undefined;
    }
    const db = getFirestoreDb();
    const qy = query(
      collection(db, 'users', ownerId, 'calendarTabEntries'),
      where('tourId', '==', tourId),
      where('date', '==', dateKey)
    );
    return onSnapshot(
      qy,
      (snap) => {
        const next = {};
        snap.forEach((d) => {
          const row = d.data() || {};
          const tabKey = String(row.tabKey || '');
          if (!tabKey) return;
          next[tabKey] = getTabEntryPublishedText(row);
        });
        setTabs(next);
      },
      () => setTabs({})
    );
  }, [ownerId, tourId, dateKey]);

  return (
    <View style={[styles.wrap, { backgroundColor: theme.background.primary }]}>
      <MasterTourContacts
        venueName={venueName}
        cityLine={cityLine}
        contactsText={tabs.CONTACTS || ''}
        partyMembers={[]}
        isDarkMode={isDarkMode}
        accent={theme.brand?.accent}
        viewerMode
      />
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: { width: '100%' },
});
